module.exports = __webpack_public_path__ + "img/login-left.aab121a0.png";